import styled from 'styled-components';

export const CreativesTableWrapperV2 = styled.div`
  margin: 20px;
  padding: 0 10px 0 10px;
  background-color: white;
  border-radius: 10px;
  height: 80vh;

  .resizable-table-wrapper {
    position: relative;
  }

  .resizable-table-extra-actions {
    position: absolute;
    top: 0;
    left: 220px;
    z-index: 1;
    display: flex;
    gap: 8px;
    height: 32px;
    align-items: center;
  }
`;
